import generator from '../util/generator';

export default generator.generate('fontPadding', 'includeFontPadding', [
    ['default', 'true'],
    'false',
]);
